import { GridSearchEntityInstance } from '@models/module/grid';

export type RemoveIndex<T> = {
  [K in keyof T as string extends K ? never : number extends K ? never : K]: T[K];
};

export type GenericObjectType<K extends string | number = string, V = string> = {
  [key in K]: V;
};

export type ListResponse<T> = {
  data: T[];
  records: number;
  sysAdminUIInfo?: SysAdminUiInfo;
};

export type SysAdminUiInfo = {
  debugSql: string;
  debugSqlExecutionDurationMs: number;
};

export const EMPTY_LIST_RESPONSE: ListResponse<GridSearchEntityInstance> = {
  data: [],
  records: 0,
};

export const nameof = <T extends object>(selector: (obj: T) => T[keyof T]): string => {
  let propertyName = '';
  const proxy = new Proxy(
    {},
    {
      get: (_target, prop) => {
        propertyName = prop as string;
        return undefined;
      },
    },
  );
  selector(proxy as T);
  return propertyName;
};
